<nb-actions size="small" class="header-left">
  <nb-action>
    <nb-icon
      icon="menu-2-outline"
      class="header-menu-icon"
      (click)="toggle()"
    ></nb-icon>
  </nb-action>
  <nb-action>
    <a [routerLink]="[selectedContract, 'home']">
      <img src="assets/images/ethinking-logo.svg" height="50" alt="home" />
      <span>ethinking.push {{ stage }}</span>
    </a>
  </nb-action>
</nb-actions>

<nb-actions size="small">
  <nb-action
    *ngIf="contractSelectItems.length"
    matripple
    [nbContextMenu]="contractSelectItems"
    nbContextMenuTag="contract-select"
  >
    <span class="">{{ selectedContractName }}</span>
    <nb-icon icon="chevron-down-outline"></nb-icon>
  </nb-action>

  <nb-action
    *ngIf="queue.length"
    [nbPopover]="templatePushProgress"
    nbPopoverPlacement="bottom"
  >
    <div class="progress-circle" [attr.data-percentage-circle]="readyState">
      <span class="progress-left">
        <span class="progress-bar"></span>
      </span>
      <span class="progress-right">
        <span class="progress-bar"></span>
      </span>
      <div class="progress-value">
        <nb-icon icon="paper-plane-outline"></nb-icon>
      </div>
    </div>
  </nb-action>

  <nb-action
    [nbContextMenu]="profileMenuItems"
    nbContextMenuTag="profile"
    *ngIf="profileMenuItems.length"
  >
    <nb-user
      class="header__user"
      [name]="users?.name"
      showName="false"
      color="#edf1f7"
    >
    </nb-user>
    <nb-icon icon="chevron-down-outline"></nb-icon>
  </nb-action>
</nb-actions>

<ng-template #templatePushProgress>
  <div class="push-progress">
    <nb-list>
      <nb-list-item *ngFor="let push of queue">
        <div class="progress-top mb-1">
          <span
            ><strong>{{ push.title }}</strong></span
          >
        </div>
        <progress max="100" [value]="push.readyState"></progress>
        <div class="progress-bottom mt-1">
          <span
            >{{ "Devices" | translate }}
            {{ push.successCount + push.errorCount + push.noFeedbackCount }} /
            {{ push.totalCount }}</span
          >
        </div>
      </nb-list-item>
    </nb-list>
  </div>
</ng-template>
